import React from "react";
import { Helmet } from "react-helmet";
import get from "lodash/get";
import find from "lodash/find";
import uniq from "lodash/uniq";
import { connect } from "react-redux";
import {
  TRANSLATIONS_STORAGE_KEY,
  TIMESTAMP_STORAGE_KEY,
} from "../../constants";

import {
  Switch,
  Layout,
  Alert,
  Row,
  Col,
  Button,
  Checkbox,
  message,
} from "antd";

import MyProfileForm from "../../components/MyProfileForm/MyProfileForm";
import ResetProfileForm from "../../components/ResetProfileForm/ResetProfileForm";
import UserProfileIdForm from "../../components/ResetProfileForm/UserProfileIdForm";

import {
  getQRCodeRequest,
  getAccountInfoRequest,
  getTwoFactorRequest,
  setTwoFactorRequest,
  updateTwoFactorMethodsRequest,
  getNotificationSettingsRequest,
  setNotificationSettingsRequest,
} from "../../api/requests";
import {
  getTwoFactorReadPermission,
  getTwoFactorUpdatePermission,
  getTwoFactorCreatePermission,
  getTwoFactorDeletePermission,
  getNotificationRandomizationSummaryBySelfPermission,
  getNotificationRandomizationSummaryByOthersPermission,
  getNotificationRandomizationSummaryGlobalPermission,
  getNotificationDepotRandomizationDetailedPermission,
  getNotification2DayReminderPermission,
  getNotification7DayReminderPermission,
  getNotificationRandomizationDetailedBySelfPermission,
  getNotificationRandomizationDetailedByOthersPermission,
  getNotificationReportSummaryPermission,
  getNotificationNewUserWelcomePermission,
  getNotificationNewUserPermission,
  getNotificationNewSitePermission,
  getNotificationSuspendedSitePermission,
  getNotificationDeathPermission,
  getNotificationFollowUpEventsPermission,
  getNotificationLowDrugStockPermission,
  getNotificationDrugExpirePermission,
  getNotificationDeviationOccurredPermission,
  getNotificationDocumentPendingApprovalPermission,
  getNotificationDocumentExpiredPermission,
  getNotificationDocumentDocumentApprovedPermission,
  getNotificationDrugReallocateSummaryPermission,
  getNotificationDrugReallocateDetailedPermission,
  getProfileDrugReallocatePermission,
  getProfileDrugReallocateSummaryPermission,
  getProfileDrugReallocateDetailedPermission,
  getUnblindingRequestPiPermission,
  getUnblindingRequestPvPermission,
  getBlindedRequestAccessPermission,
  getUnblindingRequestPendingPermission,
  getNotificationSiteRandomizationStatusChangedPermission,
  getNotificationUserStatusChangedPermission,
  getNotificationUserRoleChangedPermission,
  getNotificationQuarantinedDrugPermission,
  getNotificationDrugShipmentReceivedAtSitePermission,
  getNotificationDrugShipmentReceivedAtFridgePermission,
  getNotificationVisitReminder5Permission,
  getNotificationVisitReminder6Permission,
  getNotificationVisitReminder7Permission,
  getNotificationNewsletterPermission,
  getNotificationRandomizationClosedPermission,
  getMyProfileUpdatePermission,
  getNotificationSubjectVoidedBySelfPermission,
  getNotificationSubjectVoidedByOthersPermission,
  getNotificationSubjectVoidedGlobalPermission,
  getReceiveAuditLogNotificationEmailsPermission,
  getLanguages,
  getUserToken, getMyProfileViewIdPermission,
} from "../../reducers/user/selectors";

import isAuthenticated from "../../utils/isAuthenticated";
import classes from "./MyProfile.css";
import { logout, setAccountInfo } from "../../reducers/user/actions";
import { withNamespaces } from "react-i18next";
import moment from "moment-timezone";

const { Content } = Layout;


const getUserExpireState = (remainingDays, passwordExpireDate) => {
  try{
    let isExpired = false;
    let soonExpires = false;
    let expirationDate = null;
    if (!remainingDays && !passwordExpireDate){
      return null;
    }

    if (remainingDays !== null && remainingDays !== undefined) {
      expirationDate = moment().add(remainingDays, 'days');
    }
    if (passwordExpireDate){
      expirationDate = moment(passwordExpireDate);
    }
    if (expirationDate){
      isExpired = expirationDate.isSameOrBefore(moment(), 'day');
      soonExpires = expirationDate.isSameOrBefore(moment().add(7, 'days'), 'day');
    }
    if (isExpired){
      return 'expired';
    }
    if (soonExpires){
      return 'soon_expires';
    }
    return null
  }catch(e){
    return null
  }
};


class MyProfile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      qrCode: null,
      authenticationEnabled: false,
      isAuthenticationRequest: true,
      authError: "",
      username: "",
      profile: null,
      isProfileEdit: false,
      isPasswordEdit: false,
      twoFaCheckedList: [],
      notificationsCheckedList: [],
      notificationOptions: [],
      profileCode: null,
      showProfileCodeForm: false,
    };
  }

  componentDidMount() {
    if (this.props.twoFactorReadPermission) {
      this.getQR();
    }
    this.getProfile();
    this.getNotifications();

    const notificationOptions = [];

    if (this.props.notificationRandomizationSummaryBySelfPermission) {
      notificationOptions.push({
        key: "notification_randomization_summary_by_self",
        value: this.props.i18n.t(
          "NamespaceMyProfile:Notification randomization summary (by self)"
        ),
        group: "randomization",
      });
    }
    if (this.props.notificationRandomizationSummaryByOthersPermission) {
      notificationOptions.push({
        key: "notification_randomization_summary_by_others_in_site",
        value: this.props.i18n.t(
          "NamespaceMyProfile:Notification randomization summary (by others in site)"
        ),
        group: "randomization",
      });
    }
    if (this.props.notificationRandomizationSummaryGlobalPermission) {
      notificationOptions.push({
        key: "global_notification_randomization_summary",
        value: this.props.i18n.t(
          "NamespaceMyProfile:Notification randomization summary global"
        ),
        group: "randomization",
      });
    }
    if (this.props.notificationRandomizationDetailedBySelfPermission) {
      notificationOptions.push({
        key: "notification_randomization_detailed_by_self",
        value: this.props.i18n.t(
          "NamespaceMyProfile:Notification randomization detailed (by self)"
        ),
        group: "randomization",
      });
    }
    if (this.props.notificationRandomizationDetailedByOthersPermission) {
      notificationOptions.push({
        key: "notification_randomization_detailed_by_others_in_site",
        value: this.props.i18n.t(
          "NamespaceMyProfile:Notification randomization detailed (by others in site)"
        ),
        group: "randomization",
      });
    }
    if (this.props.notificationDepotRandomizationDetailedPermission) {
      notificationOptions.push({
        key: "notification_depot_randomization_detailed",
        value: this.props.i18n.t(
          "NamespaceMyProfile:Notification depot randomization detailed"
        ),
        group: "randomization",
      });
    }
    if (this.props.notification2DayReminderPermission) {
      notificationOptions.push({
        key: "notification_2_day_reminder",
        value: this.props.i18n.t(
          "NamespaceMyProfile:Notification 2 day reminder"
        ),
        group: "randomization",
      });
    }
    if (this.props.notification7DayReminderPermission) {
      notificationOptions.push({
        key: "notification_7_day_reminder",
        value: this.props.i18n.t(
          "NamespaceMyProfile:Notification 7 day reminder"
        ),
        group: "randomization",
      });
    }
    if (this.props.notificationDrugReallocateSummaryPermission) {
      notificationOptions.push({
        key: "notification_profile_drug_reallocate_summary",
        value: this.props.i18n.t(
          "NamespaceMyProfile:Notification profile drug reallocate summary"
        ),
        group: "randomization",
      });
    }
    if (this.props.notificationDrugReallocateDetailedPermission) {
      notificationOptions.push({
        key: "notification_profile_drug_reallocate_detailed",
        value: this.props.i18n.t(
          "NamespaceMyProfile:Notification profile drug reallocate detailed"
        ),
        group: "randomization",
      });
    }
    // if (this.props.profileDrugReallocatePermission) { notificationOptions.push({ key: 'patient_profile_drug_reallocate', value: 'Patient profile drug reallocate', group: 'randomization'}); }
    // if (this.props.profileDrugReallocateSummaryPermission) { notificationOptions.push({ key: 'patient_profile_drug_reallocate_summary', value: 'Patient profile drug reallocate summary', group: 'randomization'}); }
    // if (this.props.profileDrugReallocateDetailedPermission) { notificationOptions.push({ key: 'patient_profile_drug_reallocate_detailed', value: 'Patient profile drug reallocate detailed', group: 'randomization'}); }
    if (this.props.notificationReportSummaryPermission) {
      notificationOptions.push({
        key: "report_subject_summary",
        value: this.props.i18n.t("NamespaceMyProfile:Report subject summary"),
        group: "randomization",
      });
    }

    if (this.props.unblindingRequestPiPermission) {
      notificationOptions.push({
        key: "notification_unblinding_request_pi",
        value: this.props.i18n.t(
          "NamespaceMyProfile:Notification unblinding request pi"
        ),
        group: "randomization",
      });
    }
    if (this.props.unblindingRequestPvPermission) {
      notificationOptions.push({
        key: "notification_unblinding_request_pv",
        value: this.props.i18n.t(
          "NamespaceMyProfile:Notification unblinding request pv"
        ),
        group: "randomization",
      });
    }
    if (this.props.blindedRequestAccessPermission) {
      notificationOptions.push({
        key: "notification_blinded_request",
        value: this.props.i18n.t(
          "NamespaceMyProfile:Notification blinded request"
        ),
        group: "randomization",
      });
    }
    if (this.props.unblindingRequestPendingPermission) {
      notificationOptions.push({
        key: "notification_unblinding_request_pending",
        value: this.props.i18n.t(
          "NamespaceMyProfile:Notification unblinding request pending"
        ),
        group: "randomization",
      });
    }

    if (this.props.notificationNewUserWelcomePermission) {
      notificationOptions.push({
        key: "notification_new_user_welcome",
        value: this.props.i18n.t(
          "NamespaceMyProfile:Notification new user welcome"
        ),
        group: "admin",
      });
    }
    if (this.props.notificationNewUserPermission) {
      notificationOptions.push({
        key: "notification_new_user",
        value: this.props.i18n.t("NamespaceMyProfile:Notification new user"),
        group: "admin",
      });
    }
    if (this.props.notificationNewSitePermission) {
      notificationOptions.push({
        key: "notification_new_site",
        value: this.props.i18n.t("NamespaceMyProfile:Notification new site"),
        group: "admin",
      });
    }
    if (this.props.notificationSuspendedSitePermission) {
      notificationOptions.push({
        key: "notification_suspended_site",
        value: this.props.i18n.t(
          "NamespaceMyProfile:Notification suspended site"
        ),
        group: "admin",
      });
    }
    if (this.props.notificationDeathPermission) {
      notificationOptions.push({
        key: "notification_death",
        value: this.props.i18n.t("NamespaceMyProfile:Notification death"),
        group: "admin",
      });
    }
    if (this.props.notificationFollowUpEventsPermission) {
      notificationOptions.push({
        key: "notification_follow_up_events",
        value: this.props.i18n.t(
          "NamespaceMyProfile:Notification follow up events"
        ),
        group: "admin",
      });
    }
    if (this.props.notificationLowDrugStockPermission) {
      notificationOptions.push({
        key: "notification_low_drug_stock",
        value: this.props.i18n.t(
          "NamespaceMyProfile:Notification low drug stock"
        ),
        group: "admin",
      });
    }
    if (this.props.notificationDrugExpirePermission) {
      notificationOptions.push({
        key: "notification_drug_expire",
        value: this.props.i18n.t(
          "NamespaceMyProfile:Notification drug expiry"
        ),
        group: "admin",
      });
    }
    if (this.props.notificationDocumentPendingApprovalPermission) {
      notificationOptions.push({
        key: "notification_document_pending_approval",
        value: this.props.i18n.t(
          "NamespaceMyProfile:Notification document pending approval"
        ),
        group: "admin",
      });
    }
    if (this.props.notificationDocumentDocumentApprovedPermission) {
      notificationOptions.push({
        key: "notification_document_document_approved",
        value: this.props.i18n.t(
          "NamespaceMyProfile:Notification document approved"
        ),
        group: "admin",
      });
    }

    if (this.props.notificationDocumentExpiredPermission) {
      notificationOptions.push({
        key: "notification_document_expired",
        value: this.props.i18n.t(
          "NamespaceMyProfile:Notification document expired"
        ),
        group: "admin",
      });
    }

    if (this.props.notificationNewsletterPermission) {
      notificationOptions.push({
        key: "notification_newsletter",
        value: this.props.i18n.t("NamespaceMyProfile:Notification newsletter"),
        group: "admin",
      });
    }

    if (this.props.notificationSiteRandomizationStatusChangedPermission) {
      notificationOptions.push({
        key: "notification_site_randomization_status_changed",
        value: this.props.i18n.t(
          "NamespaceMyProfile:Notification site randomization status changed"
        ),
        group: "admin",
      });
    }
    if (this.props.notificationUserStatusChangedPermission) {
      notificationOptions.push({
        key: "notification_user_status_changed",
        value: this.props.i18n.t(
          "NamespaceMyProfile:Notification user status changed"
        ),
        group: "admin",
      });
    }
    if (this.props.notificationUserRoleChangedPermission) {
      notificationOptions.push({
        key: "notification_user_role_changed",
        value: this.props.i18n.t(
          "NamespaceMyProfile:Notification user role changed"
        ),
        group: "admin",
      });
    }
    if (this.props.notificationQuarantinedDrugPermission) {
      notificationOptions.push({
        key: "notification_quarantined_drug",
        value: this.props.i18n.t(
          "NamespaceMyProfile:Notification quarantined drug"
        ),
        group: "admin",
      });
    }
    if (this.props.notificationDrugShipmentReceivedAtSitePermission) {
      notificationOptions.push({
        key: "notification_drug_shipment_received_at_site",
        value: this.props.i18n.t(
          "NamespaceMyProfile:Notification drug shipment received at site"
        ),
        group: "admin",
      });
    }
    if (this.props.notificationDrugShipmentReceivedAtFridgePermission) {
      notificationOptions.push({
        key: "notification_drug_shipment_received_at_fridge",
        value: this.props.i18n.t(
          "NamespaceMyProfile:Notification drug shipment received at fridge"
        ),
        group: "admin",
      });
    }
    if (this.props.notificationVisitReminder5Permission) {
      notificationOptions.push({
        key: "notification_visit_reminder_5",
        value: this.props.i18n.t(
          "NamespaceMyProfile:Notification visit reminder 5"
        ),
        group: "admin",
      });
    }
    if (this.props.notificationVisitReminder6Permission) {
      notificationOptions.push({
        key: "notification_visit_reminder_6",
        value: this.props.i18n.t(
          "NamespaceMyProfile:Notification visit reminder 6"
        ),
        group: "admin",
      });
    }
    if (this.props.notificationVisitReminder7Permission) {
      notificationOptions.push({
        key: "notification_visit_reminder_7",
        value: this.props.i18n.t(
          "NamespaceMyProfile:Notification visit reminder 7"
        ),
        group: "admin",
      });
    }
    if (this.props.notificationRandomizationClosedPermission) {
      notificationOptions.push({
        key: "notification_randomization_closed",
        value: this.props.i18n.t(
          "NamespaceMyProfile:Notification randomization closed"
        ),
        group: "admin",
      });
    }

    if (this.props.notificationSubjectVoidedBySelfPermission) {
      notificationOptions.push({
        key: "notification_subject_voided_by_self",
        value: this.props.i18n.t(
          "NamespaceMyProfile:Notification subject voided (by self)"
        ),
        group: "randomization",
      });
    }
    if (this.props.notificationSubjectVoidedByOthersPermission) {
      notificationOptions.push({
        key: "notification_subject_voided_by_others_in_site",
        value: this.props.i18n.t(
          "NamespaceMyProfile:Notification subject voided (by others in site)"
        ),
        group: "randomization",
      });
    }
    if (this.props.notificationSubjectVoidedGlobalPermission) {
      notificationOptions.push({
        key: "global_notification_subject_voided",
        value: this.props.i18n.t(
          "NamespaceMyProfile:Notification subject voided global"
        ),
        group: "randomization",
      });
    }
    if (this.props.receiveAuditLogNotificationEmailsPermission) {
      notificationOptions.push({
        key: "receive_audit_log_notification_emails",
        value: this.props.i18n.t(
          "NamespaceMyProfile:Receive Audit Log Notifications (ADMIN)"
        ),
        group: "admin",
      });
    }

    this.setState({ notificationOptions });
  }

  getQR = async () => {
    try {
      const { data } = await getQRCodeRequest();
      this.setState({ qrCode: data });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      console.log(e);
    }

    try {
      const {
        data: {
          is_2fa_enabled,
          username,
          is_2fa_email_enabled,
          is_2fa_sms_enabled,
          is_2fa_mobile_app_enabled,
        },
      } = await getTwoFactorRequest();
      const twoFaCheckedList = [];
      if (is_2fa_email_enabled) {
        twoFaCheckedList.push("Email");
      }
      if (is_2fa_sms_enabled) {
        twoFaCheckedList.push("SMS");
      }
      if (is_2fa_mobile_app_enabled) {
        twoFaCheckedList.push("Google Authenticator");
      }

      this.setState({
        authenticationEnabled: is_2fa_enabled,
        username,
        twoFaCheckedList,
      });
    } catch (e) {
      console.log(e);
    }

    this.setState({ isAuthenticationRequest: false });
  };

  getProfile = async () => {
    try {
      this.props.setAccountInfo(this.props.token);
      const { data } = await getAccountInfoRequest();
      this.setState({ profile: data });
    } catch (e) {
      console.log(e);
    }
  };

  getNotifications = async () => {
    try {
      const { data } = await getNotificationSettingsRequest();

      const notificationsCheckedList = [];
      Object.keys(data).forEach((item) => {
        if (data[item]) {
          notificationsCheckedList.push(
            get(
              find(this.state.notificationOptions, (o) => o.key === item),
              "value"
            )
            // item.replace(/_/g, " ").replace(/^\w/, (c) => c.toUpperCase())
          );
        }
      });

      this.setState({ notificationsCheckedList });
    } catch (e) {
      console.log(e);
    }
  };

  onChangeNotifications = (group) => async (notificationsGroup) => {
    let notificationsCheckedListFiltered = this.state.notificationOptions
      .filter(
        (opt) =>
          this.state.notificationsCheckedList.includes(opt.value) &&
          opt.group !== group
      )
      .map((item) => item.value);

    const notifications = uniq([
      ...notificationsCheckedListFiltered,
      ...notificationsGroup,
    ]);
    const { notificationOptions } = this.state;
    const notificationsCheckedList = {};

    console.log(notificationOptions, notifications);

    notificationOptions.forEach((item) => {
      notificationsCheckedList[item.key] =
        notifications.includes(item.value) || false;
    });

    try {
      await setNotificationSettingsRequest(notificationsCheckedList);
      this.setState({ notificationsCheckedList: notifications });
      message.success(this.props.i18n.t("Saved"));
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error(get(e, "response.data.errors._schema[0]"));
      console.log(e);
    }
  };

  onChangeAuthentication = async (checked) => {
    this.setState({ isAuthenticationRequest: true });

    try {
      await setTwoFactorRequest(checked ? "enable" : "disable");
      this.setState({ authenticationEnabled: checked });
      message.success(this.props.i18n.t("Saved"));
    } catch (e) {
      this.setState({ authError: get(e, "response.data.error") });
    }

    this.setState({ isAuthenticationRequest: false });
  };

  onProfileEdit = () => {
    this.setState({ isProfileEdit: true });
  };

  onProfileEditHide = () => {
    this.setState({ isProfileEdit: false });
  };

  onSubmitProfile = () => {
    this.getProfile();
    setTimeout(() => {
      this.onProfileEditHide();
    }, 1500);

    window.localStorage.removeItem(TRANSLATIONS_STORAGE_KEY);
    window.localStorage.removeItem(TIMESTAMP_STORAGE_KEY);
    window.location.reload();
  };

  onChange2FA = async (twoFaCheckedList) => {
    const updated2FA = {
      is_2fa_mobile_app_enabled: twoFaCheckedList.includes(
        "Google Authenticator"
      ),
      is_2fa_email_enabled: twoFaCheckedList.includes("Email"),
      is_2fa_sms_enabled: twoFaCheckedList.includes("SMS"),
    };

    try {
      await updateTwoFactorMethodsRequest(updated2FA);
      this.setState({ twoFaCheckedList });
      message.success(this.props.i18n.t("Saved"));
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error(get(e, "response.data.errors._schema[0]"));
      console.log(e);
    }
  };

  onPasswordEditToggle = () => {
    this.setState((state) => ({ isPasswordEdit: !state.isPasswordEdit }));
  };

  onShowUserId = () => {
    this.setState({
      showProfileCodeForm: true,
    });
  };

  render() {
    const {
      qrCode,
      authenticationEnabled,
      isAuthenticationRequest,
      authError,
      profile,
      isProfileEdit,
      twoFaCheckedList,
      notificationsCheckedList,
      isPasswordEdit,
      notificationOptions,
      profileCode,
      showProfileCodeForm,
    } = this.state;
    const {
      twoFactorReadPermission,
      twoFactorUpdatePermission,
      twoFactorCreatePermission,
      twoFactorDeletePermission,
      myProfileUpdatePermission,
    } = this.props;
    return (
      <div>
        <Helmet>
          <title>
            {this.props.i18n.t("NamespaceMyProfile:Trial Management Portal")}:{" "}
            {this.props.i18n.t("NamespaceMyProfile:My Profile")}
          </title>
        </Helmet>
        <Layout className={classes.parentContainer}>
          <Content className={classes.content}>
            <Row gutter={8}>
              <Col lg={12}>
                <h3 className="headline-default">
                  {this.props.i18n.t("NamespaceMyProfile:My Profile")}
                </h3>
                {profile && (
                  <h4 className="headline-default">
                    {this.props.i18n.t("NamespaceMyProfile:Welcome")},{" "}
                    {get(profile, "first_name")
                      ? `${get(profile, "first_name")} ${get(
                          profile,
                          "last_name"
                        )}`
                      : get(profile, "email")}
                  </h4>
                )}
                {(profile && (profile.password_expire_days || get(profile, 'password_expire_date'))) && (
                    <div>
                       <p
                        style={{
                          color: "#555555",
                          fontSize: "14px",
                          marginTop: "-5px",
                        }}
                      >
                        {profile.password_expire_days}{" "}
                        {this.props.i18n.t(
                          "NamespaceMyProfile:days until password expire"
                        )}
                      </p>

                      {getUserExpireState(get(profile, 'password_expire_days'), get(profile, 'password_expire_date')) === 'expired' && (
                        <Alert
                          message={this.props.i18n.t('NamespaceSettingsUserForm:Password has expired!')}
                          type="error"
                          showIcon
                        />
                      )}
                      {getUserExpireState(get(profile, 'password_expire_days'), get(profile, 'password_expire_date')) === 'soon_expires' && (
                        <Alert
                          message={this.props.i18n.t('NamespaceSettingsUserForm:Password will expire soon')}
                          type="warning"
                          showIcon
                        />
                      )}
                    </div>

                )}
                <br />

                {twoFactorReadPermission && (
                  <div>
                    <h5 className="headline-default">
                      {this.props.i18n.t(
                        "NamespaceMyProfile:Enable 2 factor authentication"
                      )}
                    </h5>
                    <Switch
                      disabled={
                        !(
                          twoFactorCreatePermission || twoFactorDeletePermission
                        ) || !myProfileUpdatePermission
                      }
                      checked={authenticationEnabled}
                      onChange={this.onChangeAuthentication}
                      loading={isAuthenticationRequest}
                    />
                    {authError && (
                      <div>
                        <br />
                        <Alert
                          message={authError}
                          type="error"
                          class={classes.alertStyle}
                        />
                      </div>
                    )}

                    <br />
                    <br />

                    {twoFactorUpdatePermission && (
                      <div>
                        <h5 className="headline-default">
                          {this.props.i18n.t("NamespaceMyProfile:2FA type")}:
                        </h5>
                        <Checkbox.Group
                          disabled={
                            !twoFactorUpdatePermission ||
                            !myProfileUpdatePermission
                          }
                          options={["Google Authenticator", "Email", "SMS"]}
                          value={twoFaCheckedList}
                          onChange={this.onChange2FA}
                        />

                        <br />
                        <br />

                        <h5 className="headline-default">
                          {this.props.i18n.t(
                            "NamespaceMyProfile:QR-code for 2FA-mobile apps"
                          )}
                          :
                        </h5>
                        <p>
                          {this.props.i18n.t(
                            "NamespaceMyProfile:You can use Google Authenticator mobile app"
                          )}
                        </p>
                        <div
                          className={classes.qrWrapper}
                          dangerouslySetInnerHTML={{ __html: qrCode }}
                        />
                        <br />
                        <br />
                      </div>
                    )}
                  </div>
                )}

                <h5 className="headline-default">
                  {this.props.i18n.t(
                    "NamespaceMyProfile:Randomization platform notifications"
                  )}
                  :
                </h5>
                <Checkbox.Group
                  disabled={!myProfileUpdatePermission}
                  className={classes.notificationGroup}
                  options={notificationOptions
                    .filter((item) => {
                      return item.group === "randomization";
                    })
                    .map((item) => item.value)}
                  value={notificationsCheckedList}
                  onChange={this.onChangeNotifications("randomization")}
                />
                <br />

                <h5 className="headline-default">
                  {this.props.i18n.t("NamespaceMyProfile:Admin notifications")}:
                </h5>
                <Checkbox.Group
                  disabled={!myProfileUpdatePermission}
                  className={classes.notificationGroup}
                  options={notificationOptions
                    .filter((item) => item.group === "admin")
                    .map((item) => item.value)}
                  value={notificationsCheckedList}
                  onChange={this.onChangeNotifications("admin")}
                />
              </Col>
              <Col lg={12}>
                {!isProfileEdit ? (
                  <div className={classes.profileDetailsWrappers}>
                    <h3 className="headline-default">
                      {this.props.i18n.t("NamespaceMyProfile:Profile details")}
                    </h3>
                    <p>
                      <b>{this.props.i18n.t("Email")}:</b>{" "}
                      {get(profile, "email")}
                    </p>
                    <p>
                      <b>{this.props.i18n.t("First name")}:</b>{" "}
                      {get(profile, "first_name") ||
                        this.props.i18n.t("NamespaceMyProfile:not indicated")}
                    </p>
                    <p>
                      <b>{this.props.i18n.t("Last name")}:</b>{" "}
                      {get(profile, "last_name") ||
                        this.props.i18n.t("NamespaceMyProfile:not indicated")}
                    </p>
                    <p>
                      <b>{this.props.i18n.t("NamespaceMyProfile:Timezone")}:</b>{" "}
                      {get(profile, "time_zone") ||
                        this.props.i18n.t("NamespaceMyProfile:not indicated")}
                    </p>
                    <p>
                      <b>
                        {this.props.i18n.t("NamespaceMyProfile:Short Timezone")}
                        :
                      </b>{" "}
                      {get(profile, "short_tz") ||
                        this.props.i18n.t("NamespaceMyProfile:not indicated")}
                    </p>
                    <p>
                      <b>{this.props.i18n.t("Phone number")}:</b>{" "}
                      {get(profile, "phone_number") ||
                        this.props.i18n.t("NamespaceMyProfile:not indicated")}
                    </p>
                    {this.props.myProfileUpdatePermission && (
                      <p>
                        <Button
                          type="primary"
                          size="large"
                          onClick={this.onProfileEdit}
                        >
                          {this.props.i18n.t("Edit")}
                        </Button>
                      </p>
                    )}
                  </div>
                ) : (
                  <MyProfileForm
                    {...profile}
                    languages={this.props.languages}
                    onCancel={this.onProfileEditHide}
                    onSubmit={this.onSubmitProfile}
                    logout={this.props.logout}
                  />
                )}

                {!isProfileEdit && isPasswordEdit ? (
                  <div style={{ maxWidth: "420px" }}>
                    <ResetProfileForm
                      myProfile
                      toggleFormVisibility={this.onPasswordEditToggle}
                    />
                  </div>
                ) : (
                  <div>
                    {this.props.myProfileUpdatePermission && (
                      <Button
                        type="primary"
                        size="large"
                        onClick={this.onPasswordEditToggle}
                      >
                        {this.props.i18n.t("NamespaceMyProfile:Edit password")}
                      </Button>
                    )}
                  </div>
                )}

                <br />
                {this.props.canViewIdPermission && <div>
                    {profileCode ? (
                      <div style={{ maxWidth: "420px" }}>
                        <h5 className="headline-default">{this.props.i18n.t("NamespaceMyProfile:User id")}</h5>
                        {profileCode}
                      </div>
                    ) : (
                      <div style={{ maxWidth: "420px" }}>
                        {showProfileCodeForm ? (
                          <UserProfileIdForm
                            onSubmit={(profileCode) => {
                              this.setState({ profileCode });
                            }}
                          />
                        ) : (
                          <Button
                            type="primary"
                            size="large"
                            onClick={this.onShowUserId}
                          >
                            {this.props.i18n.t("NamespaceMyProfile:Show user ID")}
                          </Button>
                        )}
                      </div>
                    )}
                  </div>
                }
              </Col>
            </Row>
          </Content>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    token: getUserToken(state),
    twoFactorReadPermission: getTwoFactorReadPermission(state),
    twoFactorUpdatePermission: getTwoFactorUpdatePermission(state),
    twoFactorDeletePermission: getTwoFactorDeletePermission(state),
    twoFactorCreatePermission: getTwoFactorCreatePermission(state),
    notificationRandomizationSummaryBySelfPermission: getNotificationRandomizationSummaryBySelfPermission(
      state
    ),
    notificationRandomizationSummaryByOthersPermission: getNotificationRandomizationSummaryByOthersPermission(
      state
    ),
    notificationRandomizationSummaryGlobalPermission: getNotificationRandomizationSummaryGlobalPermission(
      state
    ),
    notificationRandomizationDetailedBySelfPermission: getNotificationRandomizationDetailedBySelfPermission(
      state
    ),
    notificationRandomizationDetailedByOthersPermission: getNotificationRandomizationDetailedByOthersPermission(
      state
    ),
    notificationDepotRandomizationDetailedPermission: getNotificationDepotRandomizationDetailedPermission(
      state
    ),
    notification2DayReminderPermission: getNotification2DayReminderPermission(
      state
    ),
    notification7DayReminderPermission: getNotification7DayReminderPermission(
      state
    ),
    notificationReportSummaryPermission: getNotificationReportSummaryPermission(
      state
    ),

    notificationNewUserWelcomePermission: getNotificationNewUserWelcomePermission(
      state
    ),
    notificationNewUserPermission: getNotificationNewUserPermission(state),
    notificationNewSitePermission: getNotificationNewSitePermission(state),
    notificationSuspendedSitePermission: getNotificationSuspendedSitePermission(
      state
    ),
    notificationDeathPermission: getNotificationDeathPermission(state),
    notificationFollowUpEventsPermission: getNotificationFollowUpEventsPermission(
      state
    ),
    notificationLowDrugStockPermission: getNotificationLowDrugStockPermission(
      state
    ),
    notificationDrugExpirePermission: getNotificationDrugExpirePermission(
      state
    ),
    notificationDeviationOccurredPermission: getNotificationDeviationOccurredPermission(
      state
    ),
    notificationDocumentPendingApprovalPermission: getNotificationDocumentPendingApprovalPermission(
      state
    ),
    notificationDocumentDocumentApprovedPermission: getNotificationDocumentDocumentApprovedPermission(
      state
    ),
    notificationDocumentExpiredPermission: getNotificationDocumentExpiredPermission(
      state
    ),
    notificationDrugReallocateSummaryPermission: getNotificationDrugReallocateSummaryPermission(
      state
    ),
    notificationDrugReallocateDetailedPermission: getNotificationDrugReallocateDetailedPermission(
      state
    ),
    profileDrugReallocatePermission: getProfileDrugReallocatePermission(state),
    profileDrugReallocateSummaryPermission: getProfileDrugReallocateSummaryPermission(
      state
    ),
    profileDrugReallocateDetailedPermission: getProfileDrugReallocateDetailedPermission(
      state
    ),
    unblindingRequestPiPermission: getUnblindingRequestPiPermission(state),
    unblindingRequestPvPermission: getUnblindingRequestPvPermission(state),
    blindedRequestAccessPermission: getBlindedRequestAccessPermission(state),
    unblindingRequestPendingPermission: getUnblindingRequestPendingPermission(
      state
    ),
    notificationSiteRandomizationStatusChangedPermission: getNotificationSiteRandomizationStatusChangedPermission(
      state
    ),
    notificationUserStatusChangedPermission: getNotificationUserStatusChangedPermission(
      state
    ),
    notificationUserRoleChangedPermission: getNotificationUserRoleChangedPermission(
      state
    ),
    notificationQuarantinedDrugPermission: getNotificationQuarantinedDrugPermission(
      state
    ),
    notificationDrugShipmentReceivedAtSitePermission: getNotificationDrugShipmentReceivedAtSitePermission(
      state
    ),
    notificationDrugShipmentReceivedAtFridgePermission: getNotificationDrugShipmentReceivedAtFridgePermission(
      state
    ),
    notificationVisitReminder5Permission: getNotificationVisitReminder5Permission(
      state
    ),
    notificationVisitReminder6Permission: getNotificationVisitReminder6Permission(
      state
    ),
    notificationVisitReminder7Permission: getNotificationVisitReminder7Permission(
      state
    ),
    notificationRandomizationClosedPermission: getNotificationRandomizationClosedPermission(
      state
    ),
    notificationNewsletterPermission: getNotificationNewsletterPermission(
      state
    ),
    
    notificationSubjectVoidedBySelfPermission: getNotificationSubjectVoidedBySelfPermission(
      state
    ),
    notificationSubjectVoidedByOthersPermission: getNotificationSubjectVoidedByOthersPermission(
      state
    ),
    notificationSubjectVoidedGlobalPermission: getNotificationSubjectVoidedGlobalPermission(
      state
    ),
    receiveAuditLogNotificationEmailsPermission: getReceiveAuditLogNotificationEmailsPermission(
      state
    ),
    myProfileUpdatePermission: getMyProfileUpdatePermission(state),
    languages: getLanguages(state),
    canViewIdPermission: getMyProfileViewIdPermission(state),
  };
};

const mapDispatchToProps = { logout, setAccountInfo };

export default isAuthenticated(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(withNamespaces()(MyProfile)))
);



// WEBPACK FOOTER //
// ./src/containers/MyProfile/MyProfile.js